import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function zeroOrderQtyBuilder({parsedStatusObj}) {
  const { symbol } = parsedStatusObj;
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Attempted order has a quantity of zero.
        {symbol ? '[' + symbol + ']' : ''}
      </Body3>
    </td>
  );
}
